import { AvatarGroup } from "primereact/avatargroup";
import * as React from "react";

const PrwcAvatarGroup = (props: any) => {
  return (
    <>
      <AvatarGroup>{props.children}</AvatarGroup>
    </>
  );
};

export default PrwcAvatarGroup;
